module.exports = __webpack_public_path__ + "img/logo-black.469e9210.png";